module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-chapter element-with-heading",
    attrs: {
      "id": "chapter-2"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "chapter-2-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-title-is-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("2")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "chapter-2-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("T")]), _vm._v("he South Greenwich Hospital was a private clinic in an ominous-looking blue-brick Victorian building that to Ryker looked like it could have been an asylum from a horror film, had it not been kept in such good condition. A new wing on the eastern side of the building built out of aluminium and seven feet high panes of glass showed the relative wealth both of the company who operated the clinic and of the people who could afford to use it.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Ryker sat on a bench among the sycamore trees in the open gardens at the front of the facility. He checked his watch. Ten minutes late. He spotted movement off to his right and looked up to see Peter Winter shuffling toward him. Winter, a similar age to Ryker, still carried a youthful appearance with a thin, wrinkle-free face and full head of light-brown hair, yet he walked like he was thirty years older. A result of the bomb blast that had nearly killed him and everyone else inside the offices of the JIA the last time Ryker had worked an assignment for them.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘How’s the leg?’ Ryker asked, not getting up from the bench.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘The leg’s not too bad. My hip? That’s another story, but I won’t bore you with the details.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Winter turned, took his left foot off the floor, outstretched the leg, then more or less fell backward into the seat, grimacing as he did so.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘So here we are. Again,’ Winter said a couple of heavy breaths later, a pained look still on his face.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Here we are.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I wondered how long it would take for you to get bored living a life of nothingness.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’ve been plenty busy,’ Ryker lied.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Sure you have.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Ryker glared over at Winter. Noticed the thick bags under his eyes. He wondered what case the Commander was working. There was no doubt Ryker was intrigued about life within the JIA, now that he was no longer a part of it, even if he wouldn’t admit it to anyone. And he certainly wouldn’t ask about it.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I was here not too long ago, actually,’ Winter said.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("He slipped his hand into his pocket, brought out a battered brown leather wallet. He rummaged inside and took out a small square photo of a bald-headed blue-eyed baby.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Jessica. Six months old. She was born here.’ He nodded over to the clinic. So perhaps his newborn child, rather than a gruelling case, explained the bags under his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘You didn’t trust the NHS?’ Ryker said.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Winter shrugged, smiled. ‘There are"), _c('i', [_vm._v(" some")]), _vm._v(" benefits to what I do.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Congratulations,’ Ryker said, doing a good job of hiding his bitterness, though he had no ill feelings toward Winter. He was only jealous of how his own life was so empty in comparison, even though he could never imagine settling down and having children.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Thanks, but believe me, it’s no walk in the park. You might see me as nothing more than a desk jockey, but still, the JIA and babies are not a sleep-filled mix, that’s for sure.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I can imagine.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘But enough of that. Why don’t you explain properly what’s brought us here?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Mackie.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Winter huffed. ‘Yeah, you said that on the phone. Someone’s been using your old drop points.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Someone who doesn’t know shit about drop points.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Winter raised an eyebrow but Ryker didn’t bother to explain. The issue was, the drop points were a means of communicating only if Ryker or Mackie had somehow been compromised. As such any message sent by that means would include pre-designated code words, both to show the message as genuine but also to alert the other party to any particular threat. There was no such coding on the message left for Ryker. Yet someone had still known about the drop point. Someone who had a number for Ryker that was more than two years old. A phone he’d used in the few weeks before heading off to Russia. An assignment that saw Mackie killed and Ryker’s life turned upside down…")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I can’t believe Mackie would have been so stupid to let slip–’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Not stupid,’ Ryker said. ‘Careful. And caring. What would you do to protect your family?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Winter sighed and looked over to the hospital again. ‘I understand she’s not in a good way,’ he said. ‘But the doctors have agreed you can see her.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Thank you.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Do you want me to come too? I already have a fair idea what this might be about.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘You do?’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Winter held Ryker’s eye for a minute but didn’t elaborate.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘No. I’ll see her alone. You wait here for me if you like.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Another sigh. Winter checked his watch. ‘Yeah.’")]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-188"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/break-section-side-screen.png"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_vm._v("The inside of the hospital was clean and modern, at odds with the gloomy gothic appearance of the outside. A young male nurse called Lehman escorted Ryker through the wide and bright corridors, past numerous closed doors, most with blinds pulled down. There were no open wards here; every patient had their own private space. They eventually came to a stop and Lehman knocked on the door then slowly pushed it open and stuck his head inside. He muttered something then stepped in, closing the door behind him.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Ryker remained standing outside, straining to hear. A few seconds later came the scrape and rustle as curtains were drawn open along their runners. Lehman’s head poked out of the door again.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘She’s just woken up, but she wants to see you.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Ryker nodded and Lehman opened the door fully and stepped to the side. Ryker headed in. His eyes fell upon the frail woman sunken into the bed. Her lined face was almost as pale as the sheets that covered her body. Her hair had lost nearly all of its colour and was thin and wispy. She looked over at Ryker. She was breathing heavily, wheezing, her chest rising and falling several inches with each constricted breath. A tube ran out of each nostril to the ventilator machine by her side.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Carl,’ she said. Carl. Another name. Another life.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘Janet.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Janet Campbell. Charles McCabe’s widow. She’d never taken his surname. His decision. Protection for her, for the family – a degree of separation from him, given the clandestine and often dangerous nature of Mackie’s work.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Today was the first time Ryker had seen Janet since… No, he tried not to think about that.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Her eyes welled up as he approached. Despite himself, his own eyes filled and he had to fight hard to hold off the tears.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Ryker crouched down beside her. Thought about taking her hand, but that was a step too far. They weren’t that close. Never had been.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘I’m sorry,’ he said. ‘I–’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘You don’t need to say anything about that. It wasn’t your fault. And you got the people who killed him.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘He was like a father to me,’ Ryker said, hanging his head.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘And you were like a son to him.’")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Ryker clenched his fists in anger at all of the shit that had pervaded his life. Losing Mackie, and the circumstances surrounding his death, remained one of his most raw experiences.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘But you weren’t his son,’ Janet said, a certain coldness in her words.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The change of mood helped to bring Ryker’s focus back. He looked up. Saw the hardened look on her face.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("‘You weren’t his son,’ she said again. ‘But you can help his son. Please, Carl, you have to help my son.’")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4eac3a48","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter002.vue
// module id = 84
// module chunks = 0